const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0
})

export const formatPrice = (price: number): string => {
  return currencyFormatter.format(price / 100)
}
